import { Box, Link, Stack, Typography } from '@mui/material';
import { SearchTargetSwitch } from './SearchTargetSwitch';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { SearchTypeRadioGroup } from './SearchTypeRadioGroup';
import { SearchConditions } from './SearchConditions';

type Props = {
  isPublicSearch: boolean;
};

export function HospitalsSearchBox({ isPublicSearch }: Props) {
  return (
    <>
      <Box
        sx={{
          background: '#F5FAFA',
          px: {
            sm: 5,
            lg: 15,
          },
          py: 2,
          '@media (max-width: 800px)': {
            px: 2,
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '12px',
          }}
        >
          <Typography
            sx={{
              typography: {
                xs: 'JP/Heading/s/Bold/Tight',
                sm: 'JP/Heading/s/Bold/Tight',
              },
            }}
          >
            医療機関検索
          </Typography>

          <SearchTargetSwitch
            type={'hospital'}
            isPublicSearch={isPublicSearch}
          />
        </Box>

        <Box
          sx={{
            marginTop: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <SearchTypeRadioGroup />

          <Link
            href={`/${
              isPublicSearch ? 'public' : 'app'
            }/stations/search/word?searchTarget=hospital`}
            color="#13131D"
            underline="none"
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="end"
              sx={{
                typography: {
                  xs: 'JP/Body/s/Medium/None',
                  sm: 'JP/Body/s/Medium/None',
                },
              }}
            >
              医療機関名から検索はこちら
              <NavigateNextIcon fontSize="small" />
            </Stack>
          </Link>
        </Box>

        <Box
          sx={{
            marginTop: 1,
            display: 'flex',
            alignItems: 'center',
            '@media (max-width: 800px)': {
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
            },
          }}
        >
          <SearchConditions />
        </Box>
      </Box>
    </>
  );
}
